import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; 
import BedIcons from "../../Assets/Images/bed_icon.svg";
import BathIcons from "../../Assets/Images/bath_icon.svg";
import "./PropertyRecent.css";

const PropertyRecent = () => {
  const [properties, setProperties] = useState([]);
  const [error, setError] = useState(null);

  const apiUrl =
    "https://webapi.10ninety.co.uk/properties/";

  const headers = {
    Accept: "application/json",
    "10ninety-webapi-key": process.env.REACT_APP_API_KEY,
  };

  const fetchProperties = async () => {
    try {
      console.log("Fetching properties...");

      const response = await fetch(apiUrl, { headers });

      if (!response.ok) {
        throw new Error(`Failed to fetch. Status: ${response.status} (${response.statusText})`);
      }

      const data = await response.json();

      const sortedProperties = (data.properties || [])
        .sort((a, b) => new Date(b.create_date) - new Date(a.create_date)) // Sort by newest
        .slice(0, 3); // Limit to 3

      setProperties(sortedProperties);
      console.log("Fetched properties:", sortedProperties);
    } catch (err) {
      console.error("Fetch error:", err.message);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  return (
    <div>
      {error && <p style={{ color: "red" }}>Error: {error}</p>}
      <div className="propertyList">
        {properties.length > 0 ? (
          properties.map((property, index) => (
            <Link to={`/property-details/${property.property_ref}`} key={index} className="propertyCardLink">  {/* Wrap each property in a Link */}
              <div className="propertyCard">
                <div className="propertyImage">
                  <img src={property.images[0]?.url} alt={property.images[0]?.text || "Property Image"} />
                </div>
                <div className="propertyInfo">
                  <h4 className="propertyPrice">£{property.price.toLocaleString()}</h4>
                  <p className="propertyLocation">{[
              property.address_1
                ?.replace(/\b(Flat|Apt|Apartment)\s*\d*[A-Za-z]?\b/gi, "")
                .replace(/^\d+[A-Za-z]?\s*/, "")
                .trim(),

              property.address_2,

              property.town && !property.county
                ? property.town
                : property.county,

              property.postcode_1,
            ]
              .filter(Boolean)
              .join(", ")
              .replace(/^,\s*/, "") || "Address not available"}</p>
                  <div className="propertyDetails">
                    <span>
                      {property.bedrooms} <img className="propertyIcons" src={BedIcons} alt="Bedrooms" />
                    </span>
                    <span>
                      {property.bathrooms} <img className="propertyIcons" src={BathIcons} alt="Bathrooms" />
                    </span>
                  </div>
                </div>
              </div>
            </Link>  
          ))
        ) : (
          <p>No properties available.</p>
        )}
      </div>
    </div>
  );
};

export default PropertyRecent;
